import { Stack, Title } from '@mantine/core';
import { useBanaAtananlar } from '../api/queries';
import { AksiyonTablosu } from './aksiyon-parts';
import { BosListeNotu, QueryStatus } from './parts';

/**
 * "Bana atananlar" (F2·S2 — Kapsam §20.3 kararının vadesi doldu): dar bahçeli
 * şapkaların ANA ekranı, menü TÜM şapkalarda. Liste kullanıcının KENDİ
 * kayıtlarıdır (sunucu atanan=ben filtreler) — bahçe/şapka farkı yok.
 */
export function BanaAtananlarScreen(): React.JSX.Element {
  const aksiyonlar = useBanaAtananlar();

  return (
    <Stack>
      <Title order={3}>Bana atananlar</Title>
      <QueryStatus queries={[aksiyonlar]} />
      {aksiyonlar.isSuccess && aksiyonlar.data.length === 0 && (
        <BosListeNotu mesaj="Üzerinize atanmış aksiyon yok." />
      )}
      {aksiyonlar.isSuccess && aksiyonlar.data.length > 0 && (
        /* ✏️ T9: İPUCU CÜMLESİ SİLİNDİ. *"Kapanış onayı atayandadır"* artık
           EKSİK bir cümleydi (kapatan atayan VEYA üst merci olabilir) ve
           iç belge referansı (*"Kapsam §22.3"*) taşıyordu — kullanıcıya
           yönergemizin madde numarasını okutuyorduk (D2). Kuralın kendisi
           zaten görünür: sorumluda kapatma düğmesi ÇIKMIYOR. */
        <AksiyonTablosu rows={aksiyonlar.data} testId="bana-atananlar-listesi" />
      )}
    </Stack>
  );
}
